<template>
  <!-- 微课评比 -->
  <div>
    <vsmallheader></vsmallheader>
    <div class="metter-box">
      <div style="font-size: 14px; color: #888; display: flex; align-items: center">
        <img
          src="@/assets/resource/adresst.png"
          style="width: 15px; height: 15px; margin-right: 5px"
        />
        当前位置：
      </div>
      <span style="cursor: pointer;font-size: 14px;" @click="retrun">个人中心</span> /
      <span style="cursor: pointer;font-size: 14px;" @click="retrun">{{ basicdata.name }}</span>
    </div>
    <div class="classbox">
      <div class="data-name">{{ basicdata.name }}</div>
      <div>
        <div class="info-box">
          <div class="baom-box">
            <span class="basicdata-name">活动信息</span>
            <el-button size="mini" type="primary" @click="baoming">立即报名</el-button>
          </div>
          <div class="nav">
            <div class="nav-box">
              <div class="nav-flex">
                <span>报名开始时间：</span>
                <span>{{ basicdata.beginTime }}</span>
              </div>
              <div class="nav-flex">
                <span>发起单位：</span>
                <span>{{ basicdata.deptName }}</span>
              </div>
            </div>
            <div class="nav-box">
              <div class="nav-flex">
                <span>报名结束时间：</span>
                <span>{{ basicdata.endTime }}</span>
              </div>
              <div class="nav-flex" v-if="basicdata.fileUrl">
                <span>活动附件：</span>
                <a class="a-style" :href=" basicdata.fileUrl" download v-if="basicdata.fileUrl">下载</a>
                <span v-else>无</span>
              </div>
            </div>
          </div>
          <div class="baom-box paddingtop30">
            <span class="basicdata-name">活动简介</span>
          </div>
          <div class="nav line-height20" v-html="basicdata.introduce"></div>
          <div class="baom-box paddingtop30">
            <span class="basicdata-name">评分指标</span>
          </div>
          <div class="nav align-bet">
            <ul class="ul-style">
              <li v-for="(item, index) in ruleActivityData" :key="index" class="list-style">
                <span>{{ item.name }}</span>
                <span>{{ item.score }}</span>
              </li>
            </ul>
            <div v-if="basicdata.ruleUrl">
              附件：
              <a :href="basicdata.ruleUrl" class="a-style" download>详细评分指标</a>
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
    <el-dialog :show-close="false" :visible.sync="dialogVisible" width="50%">
      <div class="dialogheader">评比活动报名</div>
      <div class="dialogForm">
        <el-form :model="activityForm" ref="activityForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="参赛者">
            <el-input v-model="activityForm.createName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="活动作品">
            <el-upload
              :headers="headers"
              class="upload-demo"
              action="/resource/File/UploadFile"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :limit="1"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div>
              <div>
                <span>大小：不超过300M;</span>
                <span style="margin-left: 50px">视频格式：MP4、FLV、AVI;</span>
              </div>
              <div>
                <span>图片格式：JPG、PNG;</span>
                <span style="margin-left: 50px">文档格式：Word、Excel、PPT</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="pagination">
        <el-button type="primary" @click="submitres">保存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as personcen from '@/api/personcenter/index.js';
import vsmallheader from '@/views/smallHeader/index';
import { getInfo } from '@/utils/auth';
import linecom from '@/components/linecom/index';
export default {
  components: {
    vsmallheader,
    linecom,
  },
  data() {
    return {
      stepactive: 5,
      dialogVisible: false,
      stepname: ['活动发布', '作品审核', '活动评分', '成绩公布', '获奖证书'],
      stepindex: 0,
      activityForm: {},
      listQuery1: {
        page: 1,
        limit: 10,
        // count: 0,
        activityId: 0,
      },
      listQuery2: {
        page: 1,
        limit: 10,
        count: 0,
        activityId: 0,
      },
      listQuery3: {
        page: 1,
        limit: 10,
        activityId: 0,
      },
      listQueryTotal: 0,
      ResourcetableData: [],

      basicdata: {}, //基本数据资料
      auditdata: {}, //审核数据
      scoredata: {}, //评分数据
      ruleActivityData: [],
      isSubmit: false,
    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
  },
  created() {
    if (this.$route.query.isSubmit == 'true') {
      this.isSubmit = true;
    } else if (this.$route.query.isSubmit == 'false') {
      this.isSubmit = false;
    }

    this.getbasicdata();
    this.getRuleActivityInfo();
  },
  methods: {
    retrun() {
      this.$router.go(-1);
    },
    //评分指标
    getRuleActivityInfo() {
      personcen
        .GetRuleActivityInfo({ activityId: this.$route.query.id })
        .then((res) => {
          this.ruleActivityData = res.result;
        });
    },
    getbasicdata() {
      personcen.GetActivityInfo({ id: this.$route.query.id }).then((res) => {
        this.basicdata = res.result;
        let star = res.result.beginTime.slice(0, 10);
        this.basicdata.beginTime = star;
        let end = res.result.endTime.slice(0, 10);
        this.basicdata.endTime = end;
      });
    },
    baoming() {
      if (getInfo('tokens')) {
        if (this.basicdata.way == 3) {
          this.activityForm = {
            phone: '',
            email: '',
            fileUrl: '',
            fileName: '',
            activityId: this.$route.query.id,
            createId: this.$store.state.User.ids,
            createName: JSON.parse(this.$store.state.User.infos).name,
          };
          localStorage.setItem('activityId', this.$route.query.id);
          this.dialogVisible = true;
        } else {
          if (this.isSubmit) {
            this.activityForm = {
              phone: '',
              email: '',
              fileUrl: '',
              fileName: '',
              activityId: this.$route.query.id,
              createId: this.$store.state.User.ids,
              createName: JSON.parse(this.$store.state.User.infos).name,
            };
            this.dialogVisible = true;
          } else {
            this.$message.warning('您不是本次活动参赛人员，无法参加活动！');
          }
        }
      } else {
        window.clikLogin();
      }
    },
    handleSuccess(res, file, fileList) {
      this.activityForm.fileUrl = res.result;
      this.activityForm.fileName = file.name;
      let filePath = res.result.lastIndexOf('.');
      let a = {
        uploadname: file.name,
        uploadformat: res.result.substr(filePath + 1),
      };
      this.uploadData.push(a);
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    submitres() {
      if (this.activityForm.fileUrl == '') {
        this.$notify({
          title: '警告',
          message: '请先上传作品',
          type: 'warning',
        });
      } else {
        this.activityForm.activityId = localStorage.getItem('activityId') * 1;
        personcen.AddActivityResource(this.activityForm).then((res) => {
          this.$notify({
            title: '成功',
            message: '上传成功',
            type: 'success',
          });
          localStorage.removeItem('activityId');
          this.dialogVisible = false;
        });
      }
    },
  },
};
</script>
<style scoped>
.metter-box {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;
}
.heightli {
  color: rgb(130, 235, 26) !important;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.stepss {
  display: flex;
  margin: 10px 0;
  border-bottom: solid 1px #ccc;
}
.stepss > div {
  width: 240px;
  height: 30px;
  text-align: center;
  font-size: 18px;
  color: #aaa;
}
.classbox {
  margin: 0 auto;
  width: 1200px;
  min-height: 700px;
  margin-bottom: 30px;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 97%);
}
.classheader {
  padding: 20px;
  height: 210px;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
  border-radius: 5px;
  margin-top: 20px;
}
.classheader1 {
  display: flex;
  align-items: center;
}
.classheader1 > div:nth-child(1) {
  flex: 1;
  font-size: 20px;
}
.classheader1 > div:nth-child(2) {
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  padding: 0 8px;
  font-size: 18px;
  cursor: pointer;
  color: #fff;
  background-color: rgb(247, 166, 16);
  margin-left: 20px;
}
.classheader2 {
  display: flex;
}
.hdTitleBox {
  box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
  border-radius: 5px;
  margin-top: 20px;
}
.hdTitleii {
  height: 23px;
  width: 3px;
  background-color: #1492ff;
  margin-right: 15px;
}
.hdTitle {
  display: flex;
  align-items: center;
  font-size: 20px;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 0 10px 10px;
}
.headerfirst {
  flex: 1;
}
.headerfirst > div {
  line-height: 50px;
  font-size: 16px;
  color: #555;
}
.classjindu {
  width: 1200px;
  margin: 0 auto;

  margin-bottom: 20px;
  min-height: 450px;
}
.ageleft {
  width: 900px;
  /* height: 200px; */
  background-color: #fff;
  box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
}
.lable {
  width: 900px;
  height: 40px;
  border-bottom: solid 1px #ccc;
  margin: 0 auto;
  padding-top: 10px;
  display: flex;
}
.lable > div {
  flex: 1;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
}
.lable > div:hover {
  color: #409eff;
}
.heightlight {
  color: #409eff !important;
  font-weight: 700;
}
.xian {
  width: 150px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.stepmessage {
  padding: 10px 20px;
  padding-bottom: 40px;
  font-size: 16px;
}
.stepmessage > div:nth-child(1) > div:nth-child(odd) {
  padding-left: 10px;
  color: #333;
  border-left: solid 3px #1492ff;
  margin-top: 15px;
}
.stepmessage > div:nth-child(1) > div:nth-child(even) {
  font-size: 16px;
  padding-left: 10px;
  color: #555;
  text-indent: 30px;
  margin-top: 10px;
}
.dialogheader {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
}
.dialogForm {
  width: 90%;
  margin-top: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
<style lang="scss" scoped>
.data-name {
  text-align: center;
  font-size: 21px;
  font-weight: 700;
  padding: 20px 0;
}
.baom-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 10px;
  font-size: 16px;
  .basicdata-name {
    font-size: 16px;
    font-weight: 700;
  }
}
.info-box {
  padding: 10px;
}
.nav-box {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  .nav-flex {
    width: 50%;
  }
}
.nav {
  padding-top: 10px;
}
.align-bet {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.paddingtop30 {
  padding-top: 30px;
}
.ul-style {
  padding: 0 20px;
  min-height: 300px;
}
.list-style {
  line-height: 22px;
  list-style-type: disc;
  display: flex;
  justify-content: space-around;
  & > span:nth-child(1) {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  & > span:nth-child(2) {
    width: 20%;
  }
}
.line-height20 {
  line-height: 22px;
}
.a-style {
  color: #66b1ff;
  &:hover {
    text-decoration: underline;
  }
}
</style>